// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface RESTRestoreSiteConfig
 */
export interface RESTRestoreSiteConfig {
    /**
     * Specifies a user name of the account that will be used as a SharePoint site owner account to restore a SharePoint site.  **Note**: This property is required if you want to use an application certificate for data restore. Use this property only with the `applicationCertificate` property. 
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    impersonationAccountName?: string;
    /**
     * Specifies an alias for the target SharePoint site. If you omit this property, the SharePoint site items will be restored to the original location.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    alias?: string;
    /**
     * Defines whether the SharePoint lists will be restored with all list views.
     * @type {boolean}
     * @memberof RESTRestoreSiteConfig
     */
    restoreListViews?: boolean | null;
    /**
     * Defines whether the SharePoint site will be restored with all modified items.
     * @type {boolean}
     * @memberof RESTRestoreSiteConfig
     */
    changedItems?: boolean | null;
    /**
     * Defines whether the SharePoint site will be restored with all deleted items.
     * @type {boolean}
     * @memberof RESTRestoreSiteConfig
     */
    deletedItems?: boolean | null;
    /**
     * Defines whether the SharePoint site will be restored with all subsites.
     * @type {boolean}
     * @memberof RESTRestoreSiteConfig
     */
    restoreSubsites?: boolean | null;
    /**
     * Defines whether the SharePoint site will be restored with all master pages.
     * @type {boolean}
     * @memberof RESTRestoreSiteConfig
     */
    restoreMasterPages?: boolean | null;
    /**
     * Defines whether the SharePoint site will be restored with all permissions.
     * @type {boolean}
     * @memberof RESTRestoreSiteConfig
     */
    restorePermissions?: boolean;
    /**
     * Defines whether the shared links notifications will be sent.
     * @type {boolean}
     * @memberof RESTRestoreSiteConfig
     */
    sendSharedLinksNotification?: boolean | null;
    /**
     * Specifies what version of the SharePoint documents will be restored.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    documentVersion?: RESTRestoreSiteConfigDocumentVersionEnum;
    /**
     * Specifies the action that will be performed with the last version of the restored SharePoint document on the destination server.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    documentLastVersionAction?: RESTRestoreSiteConfigDocumentLastVersionActionEnum;
    /**
     * Specifies the authentication code. For more information on how to get a device code, see [Get Device Code](#tag/RestoreSession/operation/RestoreSession_DeviceCodeAction). This property is required if you want to use a device code for data restore. 
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    userCode?: string;
    /**
     * Specifies the ID of the Micrisoft Entra application that you want to use for restore.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    applicationId?: string | null;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    applicationCertificatePassword?: string;
    /**
     * Specifies the SSL certificate configured for the Microsoft Entra application that you want to use for data restore. You must provide the certificate as a Base64 string.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    applicationCertificate?: string;
    /**
     * Specifies the user name that you want to use for authenticating to the organization.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    userName?: string;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreSiteConfig
     */
    userPassword?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreSiteConfigDocumentVersionEnum {
    All = 'All',
    Last = 'Last'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreSiteConfigDocumentLastVersionActionEnum {
    Overwrite = 'Overwrite',
    Merge = 'Merge'
}

